// extracted by mini-css-extract-plugin
module.exports = {"container":"fixed-top-bar_container__2avvo"};